/**
 * Die Farbe der beiden Einstiege zum Co-Auditor.
 *
 * Eigene Werte statt `ki.main`: Jenes Orange (#e8710a) dient an sechzehn
 * Stellen als *Textfarbe auf Weiß* und liegt dort mit einem Kontrast von 3,09
 * genau auf der Grenze — heller dürfte es dort nicht werden. Hier ist es
 * umgekehrt: heller Grund, dunkler Text. Da wird heller sogar besser.
 *
 * Gemessen gegen das Navy der Schrift:
 *   #ff9800 → 6,46   ·   #ffa726 → 7,17   ·   #ffb74d → 8,04
 *
 * Beim Überfahren kehrt sich der Knopf um: kräftiges Orange, weiße Schrift.
 */
export const CHAT_ORANGE = '#ffb74d';
export const CHAT_ORANGE_AKTIV = '#f57c00';
